import React from 'react'

export const ArrowWithPercent = ({percent}: {percent: number}) => (
  <svg
    width="46"
    height="28"
    viewBox="0 0 46 28"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[46px] h-[28px]"
  >
    <rect width="38" height="28" fill="#3F8BFD" />
    <path d="M46 14L38 28L38 0L46 14Z" fill="#3F8BFD" />
    <text
      x="19"
      y="18"
      textAnchor="middle"
      fill="white"
      fontSize="12"
      fontWeight="bold"
    >
      {percent}%
    </text>
  </svg>
)
